import { useState } from "react";

import AccordionItem, { type AccordionItemData } from "./AccordionItem";

import styles from "./Accordion.module.scss";

interface AccordionProps {
  items: AccordionItemData[];
}

export default function Accordion({ items }: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className={styles.accordion}>
      {items.map((item, index) => (
        <AccordionItem
          key={item.id}
          item={item}
          index={index}
          isOpen={openIndex === index}
          onToggle={handleToggle}
        />
      ))}
    </div>
  );
}
